import clsx from 'clsx';
import { Container, Row } from 'react-bootstrap';

type ErrorLayoutProps = {
  children: React.ReactNode;
  className?: string;
};

export const ErrorLayout = ({ children, className }: ErrorLayoutProps) => (
  <div className={clsx('account-pages my-5', className)}>
    <Container>
      <Row className="justify-content-center">{children}</Row>
    </Container>
  </div>
);
